

/**
 * @ngdoc filter
 * @name app.filter:queryFormatCell
 * @function
 * @description
 * # queryFormatCell
 * Filter in the app.
 */
angular.module('app')
	.filter('queryFormatCell', /* @ngInject */ function ($filter) {
		return function (input) {
			if (angular.isString(input) && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}Z?$/.test(input)) {
				input = $filter('date')(new Date(input), 'dd/MM/yyyy HH:mm');
			}
			else if (angular.isDate(input)) {
				input = $filter('date')(input, 'dd/MM/yyyy HH:mm');
			}
			return input;
		};
	});
